/* eslint-disable */
// jshint ignore: start
import store from '@/store';

/**
 * 관리대상 이벤트 애니메이션 효과
 * @author KangBonghun(toto1323)
 * @param  {[type]} Q [description]
 * @return {[type]}   [description]
 */
(function(Q) {
  function HierarchicLayouter(graph) {
    this.graph = graph;
  }

  HierarchicLayouter.prototype = {
    getLayoutResult: function(params) {
      if (!(params instanceof Object)) {
        if (Q.isNumber(params)) {
          params = {
            xGap: params,
            yGap: params
          }
        } else {
          params = {};
        }
      }
      var xGap = params.xGap || 100;
      var yGap = params.yGap || 100;
      var graph = this.graph;

      var locations = {};

      graph.graphModel.forEachByTopoBreadthFirstSearch(function(v, from, layer, index, sum) {
        if (v._layer === undefined || layer > v._layer) {
          v._layer = layer;
          return;
        }
      });

      var layers = {};
      graph.forEach(function(element) {
        if (element._layer !== undefined) {
          var nodes = layers[element._layer];
          if (!nodes) {
            nodes = layers[element._layer] = [];
          }
          nodes.push(element);
        }
      })

      var layer = 0;
      while (true) {
        var nodes = layers[layer];
        if (!nodes) {
          break;
        }
        var width = (nodes.length - 1) * xGap;
        var x = -width / 2;
        var y = layer * yGap;
        nodes.forEach(function(node, i) {
          locations[node.id] = {
            node: node,
            x: x + i * xGap,
            y: y
          };
          delete node._layer;
        })
        layer++;
      }

      return locations;
    }
  }
  Q.extend(HierarchicLayouter, Q.Layouter);

  Q.HierarchicLayouter = HierarchicLayouter;
})(window.Q);
// jshint ignore:end
/* eslint-enable */



// WEBPACK FOOTER //
// ./src/views/topologymap/js/hierarchicLayouter.js